import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import {
  PractitionRoleActions,
  PractitionRoleActionTypes,
} from '../_actions/practition-role.actions';
import { QueryParamsModel } from '../../_base/crud';
import { PractitionRole } from '../_models/practition-role.model';

export interface PractitionRolesState extends EntityState<PractitionRole> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedPractitionRoleId: number;
  lastQuery: QueryParamsModel;
  error: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<PractitionRole> = createEntityAdapter<PractitionRole>();

export const initialPractitionRolesState: PractitionRolesState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedPractitionRoleId: undefined,
  showInitWaitingMessage: true,
});

export function practitionRolesReducer(
  state = initialPractitionRolesState,
  action: PractitionRoleActions,
): PractitionRolesState {
  switch (action.type) {
    case PractitionRoleActionTypes.PractitionRolesPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedPractitionRoleId: undefined,
      };
    case PractitionRoleActionTypes.PractitionRolesActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case PractitionRoleActionTypes.PractitionRoleOnServerCreated:
      return {
        ...state,
      };
    case PractitionRoleActionTypes.PractitionRoleOnServerUpdated:
      return {
        ...state,
      };
    case PractitionRoleActionTypes.PractitionRoleStatusOnServerUpdated:
      return {
        ...state,
      };
    case PractitionRoleActionTypes.PractitionRoleOnServerDeleted:
      return {
        ...state,
      };
    case PractitionRoleActionTypes.PractitionRoleCreated:
      return adapter.addOne(action.payload.practitionRole, {
        ...state,
        lastCreatedPractitionRoleId: action.payload.practitionRole.id,
      });
    case PractitionRoleActionTypes.PractitionRoleUpdated:
      return adapter.updateOne(action.payload.partialPractitionRole, state);
    case PractitionRoleActionTypes.PractitionRoleDeleted:
      return adapter.removeOne(action.payload.id, state);
    case PractitionRoleActionTypes.PractitionRolesPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case PractitionRoleActionTypes.PractitionRolesPageLoaded: {
      return adapter.addMany(action.payload.practitionRoles, {
        ...initialPractitionRolesState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        listLoading: false,
        showInitWaitingMessage: false,
      });
    }
    case PractitionRoleActionTypes.ThrowPractitionRoleError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case PractitionRoleActionTypes.ClearPractitionRoleErrors: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
}
export const getPractitionRoleState =
  createFeatureSelector<PractitionRolesState>('practitionRoles');
export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
